// Seggregated API Paths

const AUTH = {
  login: "/accounts/api/v1/login/",
  verifyPhone: "/accounts/api/v1/mobile-verify/",
  refresh: "/accounts/api/v1/token/refresh/",
  forgetPassword: "/accounts/api/v1/verifyresetemail/",
  verifyEmail: "/accounts/api/v2/verify-reset-email/",
  verifyToken: "/accounts/api/v2/verify-reset-token/",
  resetPassword: "/accounts/api/v2/reset-password/",
  profile: "/accounts/api/v1/user/me/",
  userSettings: "/accounts/api/v1/user/profile/",
};

const ORGANIZATION = {
  orgs: "/organization/api/v1/organization/",
  org: (id) => `/organization/api/v1/organization/${id}/`,
  clustertemplate: "/orchestrator/api/v1/clustertemplate/",
  syncTemplate: "/system/api/v1/synctemplate/",
  appsOrg: (id) => `/organization/api/v1/organization/${id}/apps/`,
};

const ORCHESTRATOR = {
  rootDnsProviders: "/orchestrator/api/v1/dnsprovider/",
};
const SIM = {
  listSim: "/sim/api/v1/sim/",
  simDetail: (simId) => `/sim/api/v1/sim/${simId}/device_details`,
  simUsage: (simId) => `/sim/api/v1/sim/${simId}/cellular_usages/`,
  simActivate: (simId) => `/sim/api/v1/sim/${simId}/activate/`,
  simDeactivate: (simId) => `/sim/api/v1/sim/${simId}/deactivate/`,
  simSuspend: (simId) => `/sim/api/v1/sim/${simId}/suspend/`,
};

const INVENTORY = {
  listInventory: "/system/api/v1/systeminventory/",
  simDropdown: "/sim/api/v1/sim/label_value/",
  systemProfile: "/system/api/v1/systemprofile/profiles/",
  inventoryReports: "/system/api/v1/systeminventoryreport/",
  inventoryReportsExport: "/system/api/v1/systeminventoryreport/export/",
};

const GROUP = {
  listGroup: "/accounts/api/v1/groups/",
  listPermissions: "/accounts/api/v1/permissions/",
  listUsers: "/accounts/api/v1/user/get_users_list_label/",
  deleteGroup: (groupId) => `/accounts/api/v1/groups/${groupId}/`,
};

const DASHBOARD = {
  homepageData: "/organization/api/v1/homepage_data/",
};

const USERS = {
  listUser: "/accounts/api/v1/user/",
};

const JOBS = {
  getJobs: "/jobs/api/v1/jobs/",
  getJob: (id) => `/jobs/api/v1/jobs/${id}/`,
};

const NOTIFICATIONS = {
  getNotifications: "/notification/api/v1/notification/",
  markAsRead: (id) => `notification/api/v1/notification/${id}/mark_read/`,
  markAllAsRead: "notification/api/v1/notification/mark_all_read/",
  deleteAll: "notification/api/v1/notification/delete_all/",
};

const allPaths = {
  ...AUTH,
  ...DASHBOARD,
  ...ORGANIZATION,
  ...SIM,
  ...INVENTORY,
  ...ORCHESTRATOR,
  ...USERS,
  ...GROUP,
  ...JOBS,
  ...NOTIFICATIONS,
};

export const getUrl = (key) => {
  return allPaths[key];
};
